import { render, staticRenderFns } from "./DataGrid.vue?vue&type=template&id=151f294f&scoped=true&"
import script from "./DataGrid.vue?vue&type=script&lang=js&"
export * from "./DataGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151f294f",
  null
  
)

export default component.exports